export enum SubscriptionPackageEnum {
  LITE = 'Lite',
  PLUS = 'Plus',
  PLUS_ORANGE_70 = 'Plus - orange 70%',
  PLUS_ORANGE_100 = 'Plus - orange 100%',
  PLUS_CIB_CLIENT = 'Plus - CIB client',
  PLSU_CIB_STAFF = 'Plus - CIB staff',
}
